import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import agricultureBg from "../../assets/images/produtos/agricola.webp";

const AgriculturalInsurance = () => {
  const serviceData = {
    heroImage: agricultureBg,
    title: "Seguro Agrícola",
    artigo: "um",
    subtitle: "Proteção completa para seu maquinário e equipamentos agrícolas",
    color: "green",
    icon: "tractor",
    ramo: "Agricola",
    pageRamo: true,
    showEmail: true,
    showVeiculo: false,
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "O seguro agrícola é fundamental para proteger seu investimento no campo contra diversos riscos, como danos a maquinários, equipamentos e implementos agrícolas. Com um seguro agrícola da Free Market Seguros, você trabalha com tranquilidade sabendo que seu patrimônio está protegido.",
      "Trabalhamos com as principais seguradoras do mercado para oferecer a você as melhores coberturas com preços competitivos, garantindo o melhor custo-benefício para seu perfil e necessidades específicas do agronegócio.",
    ],
    coverages: [
      "Danos a tratores e colheitadeiras",
      "Proteção para implementos agrícolas",
      "Cobertura contra incêndio e roubo",
      "Danos elétricos em equipamentos",
      "Responsabilidade civil operacional",
    ],
    additionalCoverages: [
      "Quebra de máquinas",
      "Danos por fenômenos naturais",
      "Perda de produção por eventos cobertos",
      "Assistência 24h para maquinário",
      "Cobertura para operadores",
    ],
    advantages: [
      {
        icon: "shield-alt",
        title: "Proteção Completa",
        description:
          "Cobertura abrangente para maquinários e equipamentos agrícolas",
      },
      {
        icon: "tools",
        title: "Assistência Técnica",
        description:
          "Suporte especializado para manutenção e reparos emergenciais",
      },
      {
        icon: "hand-holding-usd",
        title: "Custo-Benefício",
        description:
          "Proteção financeira com investimento adequado à sua operação",
      },
    ],
    steps: [
      {
        title: "Avaliação Personalizada",
        description:
          "Analisamos seu maquinário, equipamentos e necessidades específicas da sua operação agrícola.",
      },
      {
        title: "Cotação Especializada",
        description:
          "Buscamos as melhores opções de seguradoras e coberturas para seu perfil de risco.",
      },
      {
        title: "Contratação Simplificada",
        description:
          "Após escolher a melhor opção, cuidamos de toda a documentação e processo de contratação.",
      },
      {
        title: "Suporte Contínuo",
        description:
          "Oferecemos assistência durante toda a vigência da apólice, especialmente em caso de sinistros.",
      },
    ],
    tip: "Ao contratar um seguro agrícola, considere não apenas o valor dos equipamentos, mas também o impacto financeiro que uma paralisação pode causar na sua produção. Coberturas adicionais para lucros cessantes podem ser fundamentais para garantir a continuidade do seu negócio em caso de sinistros.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default AgriculturalInsurance;
